module.exports = __webpack_public_path__ + "img/cabecaExplodindo.78facad2.png";